// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nb-card {
  margin: 0;
  max-height: 80vh;
  width: 550px;
}

nb-card-body {
  max-height: 60vh;
  overflow-y: auto;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.header-content {
  flex: 1;
  min-width: 0;
}

.header-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  color: #222b45;
}

.header-hint {
  font-size: 12px;
  color: #9ba8bc;
  margin-top: 6px;
  line-height: 1.4;
  font-weight: 400;
}

.feed-connection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #edf1f7;
}
.feed-connection:first-child {
  padding-top: 0;
}
.feed-connection:last-child {
  border-bottom: none;
}

.feed-name {
  font-weight: 600;
}

.feed-hint {
  font-size: 12.5px;
  color: #8f9bb3;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInhlcm8tZmVlZC1jb25uZWN0aW9ucy5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFNBQUE7RUFDQSxnQkFBQTtFQUNBLFlBQUE7QUFDRjs7QUFFQTtFQUNFLGdCQUFBO0VBQ0EsZ0JBQUE7QUFDRjs7QUFFQTtFQUNFLGFBQUE7RUFDQSw4QkFBQTtFQUNBLHVCQUFBO0VBQ0EsU0FBQTtBQUNGOztBQUVBO0VBQ0UsT0FBQTtFQUNBLFlBQUE7QUFDRjs7QUFFQTtFQUNFLGVBQUE7RUFDQSxnQkFBQTtFQUNBLGdCQUFBO0VBQ0EsY0FBQTtBQUNGOztBQUVBO0VBQ0UsZUFBQTtFQUNBLGNBQUE7RUFDQSxlQUFBO0VBQ0EsZ0JBQUE7RUFDQSxnQkFBQTtBQUNGOztBQUVBO0VBQ0UsYUFBQTtFQUNBLG1CQUFBO0VBQ0EsOEJBQUE7RUFDQSxjQUFBO0VBQ0EsZ0NBQUE7QUFDRjtBQUNFO0VBQ0UsY0FBQTtBQUNKO0FBRUU7RUFDRSxtQkFBQTtBQUFKOztBQUlBO0VBQ0UsZ0JBQUE7QUFERjs7QUFJQTtFQUNFLGlCQUFBO0VBQ0EsY0FBQTtBQURGIiwiZmlsZSI6Inhlcm8tZmVlZC1jb25uZWN0aW9ucy5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIm5iLWNhcmQge1xuICBtYXJnaW46IDA7XG4gIG1heC1oZWlnaHQ6IDgwdmg7XG4gIHdpZHRoOiA1NTBweDtcbn1cblxubmItY2FyZC1ib2R5IHtcbiAgbWF4LWhlaWdodDogNjB2aDtcbiAgb3ZlcmZsb3cteTogYXV0bztcbn1cblxuLmhlYWRlci1jb250YWluZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIGFsaWduLWl0ZW1zOiBmbGV4LXN0YXJ0O1xuICBnYXA6IDE2cHg7XG59XG5cbi5oZWFkZXItY29udGVudCB7XG4gIGZsZXg6IDE7XG4gIG1pbi13aWR0aDogMDtcbn1cblxuLmhlYWRlci10aXRsZSB7XG4gIGZvbnQtc2l6ZTogMTZweDtcbiAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgbGluZS1oZWlnaHQ6IDEuMztcbiAgY29sb3I6ICMyMjJiNDU7XG59XG5cbi5oZWFkZXItaGludCB7XG4gIGZvbnQtc2l6ZTogMTJweDtcbiAgY29sb3I6ICM5YmE4YmM7XG4gIG1hcmdpbi10b3A6IDZweDtcbiAgbGluZS1oZWlnaHQ6IDEuNDtcbiAgZm9udC13ZWlnaHQ6IDQwMDtcbn1cblxuLmZlZWQtY29ubmVjdGlvbiB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgcGFkZGluZzogOHB4IDA7XG4gIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjZWRmMWY3O1xuXG4gICY6Zmlyc3QtY2hpbGQge1xuICAgIHBhZGRpbmctdG9wOiAwO1xuICB9XG5cbiAgJjpsYXN0LWNoaWxkIHtcbiAgICBib3JkZXItYm90dG9tOiBub25lO1xuICB9XG59XG5cbi5mZWVkLW5hbWUge1xuICBmb250LXdlaWdodDogNjAwO1xufVxuXG4uZmVlZC1oaW50IHtcbiAgZm9udC1zaXplOiAxMi41cHg7XG4gIGNvbG9yOiAjOGY5YmIzO1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/shared/ui/xero-feed-connections/xero-feed-connections.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,gCAAA;AACF;AACE;EACE,cAAA;AACJ;AAEE;EACE,mBAAA;AAAJ;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,iBAAA;EACA,cAAA;AADF;AACA,g+DAAg+D","sourcesContent":["nb-card {\n  margin: 0;\n  max-height: 80vh;\n  width: 550px;\n}\n\nnb-card-body {\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.header-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.header-title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: #222b45;\n}\n\n.header-hint {\n  font-size: 12px;\n  color: #9ba8bc;\n  margin-top: 6px;\n  line-height: 1.4;\n  font-weight: 400;\n}\n\n.feed-connection {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px solid #edf1f7;\n\n  &:first-child {\n    padding-top: 0;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.feed-name {\n  font-weight: 600;\n}\n\n.feed-hint {\n  font-size: 12.5px;\n  color: #8f9bb3;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
